import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";

export const AddButton = (props) => {
  let options = {...props}
  options.text ||= 'Adauga'
  options.size ||= 'md'
  options.className = `${options.className} btn-outline-primary`

  return <RenderLink {...options}><i className="bi bi-plus"/></RenderLink>
}

export const EditButton = (props) => {
  let options = {...props}
  options.text ||= 'Editeaza'
  options.className = `${options.className} btn-outline-primary`

  return <RenderLink {...options}><i className="bi bi-pencil"/></RenderLink>
}

export const DeleteButton = (props) => {
  let options = {...props}
  options.text ||= 'Sterge'
  options.className = `${options.className} btn-outline-danger`

  return <RenderLink {...options}><i className="bi bi-trash"/></RenderLink>
}

export const ViewButton = (props) => {
  let options = {...props}
  options.text ||= 'Detalii'
  options.className = `${options.className} btn-outline-primary`

  return <RenderLink {...options}><i className="bi bi-eye"/></RenderLink>
}

export const BackButton = (props) => {
  const navigate = useNavigate()

  let options = {...props}
  options.text ||= 'Inapoi la lista'
  options.className = `${options.className} btn-outline-secondary`

  if (!options.to)
    options.onClick = () => navigate(-1)

  return <RenderLink {...options}><i className="bi bi-arrow-left"/></RenderLink>
}

export const CustomButton = (props) => {
  const icon = props.icon || 'question-circle'

  return <RenderLink {...props}><i className={`bi bi-${icon}`}/></RenderLink>
}

export const RenderLink = (props) => {
  // link_to text, url, attrs
  let options = {
    size: props.size || 'xs',
    className: `${props.className} btn btn-${props.variant} ms-1`
  }
  if (options.size)
    options.className = options.className + ` btn-${options.size}`
  options = {...props, ...options}
  const showText = options.showText || false
  delete options.showText

  const renderTooltip = (props) => {
    return (
      <Tooltip id="button-tooltip" {...props}>
        {options.text}
      </Tooltip>
    )
  };

  if (showText)
    return <Link {...options}>{options.text}</Link>

  return (
    <OverlayTrigger placement="top" delay={{show: 150, hide: 100}} overlay={renderTooltip}>
      <Link {...options}>
        {props.children}
      </Link>
    </OverlayTrigger>
  )
}

// export function initMap(elementIdentifier = '#map', setMap) {
//   const map = new google.maps.Map($(elementIdentifier)[0], {
//     center: {lat: 46.5434858, lng: 24.6123711}, zoom: 12,
//   });
//   setMap(map);
// }
//
// export function addPinToMap(map, pin) {
//   if (!pin.lat || !pin.lon) return;
//   return new google.maps.Marker({position: {lat: pin.lat, lng: pin.lon}, map, title: pin.name});
// }
//
// export function removeMapPins(markers, setMarkers) {
//   if (markers.length == 0) return
//   markers.forEach(marker => marker.setMap(null))
//   setMarkers([])
// }